import { combineReducers } from 'redux';
import _ from 'lodash';

import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATE_ITEMS,
} from 'src/api';

import {
  FETCH_METRC_RECEIPTS_START,
  FETCH_METRC_RECEIPTS_SUCCESS,
  FETCH_METRC_RECEIPTS_FAILURE,
} from './actions';

export const transformMetrcReceipt = response => {
  return {
    receiptNumber: response.receiptnumber,
    salesTime: response.salesdatetime,
    customerType: response.salescustomertype,
    packages: response.totalpackages,
    price: response.totalprice,
    recordedBy: response.recordedbyusername,
  };
};

const fetchMetrcReceiptsReducer = createApiReducer(
  [
    FETCH_METRC_RECEIPTS_START,
    FETCH_METRC_RECEIPTS_SUCCESS,
    FETCH_METRC_RECEIPTS_FAILURE,
  ],
  (payload, state) => {
    return {
      ...state.data,
      metrcReceipts: payload.map(transformMetrcReceipt),
    };
  },
  error => _.get(error, 'payload.response', 'unknown error')
);

export const metrcReceipts = chainReducers(
  INITIAL_API_STATE_ITEMS,
  fetchMetrcReceiptsReducer
);

export const reducer = combineReducers({
  metrcReceipts,
});
